
/* Progressive enhancement only. With JS off: every router tile is a working
   link, the day card shows day 12, the FAQ is native <details>, and the
   videos are posters. Nothing shifts when this runs. (Header/drawer/megas
   are driven by maa-header-footer.js, which also runs on the homepage.) */
(function(){

  /* These regions are standalone sections now; a page may include one, several
     or none. The script only reads what is present, and runs once per page. */
  if(window.MAA_HOMEPAGE_JS){ return; }
  window.MAA_HOMEPAGE_JS = true;

  /* ---------------------------------------------------------------- PLAN
     One data structure drives the picker, the slider and the answer panel.
     The store renders it from the section settings into window.MAA_PHASES;
     the hardcoded table below is only a fallback for when the section or its
     plan block is absent.
     ------------------------------------------------------------------- */
  var CDN = 'https://maamitahara.com/cdn/shop/files/';
  var PHASES = window.MAA_PHASES || [
    { from:1, to:7, tone:'#8E3A4A',
      phase:'Days 1–7 · the first week',
      name:'Harira, Ajwain &amp; Haldi', dev:'हरीरा · अजवाइन',
      why:'Thin, warm and digestible. The first week asks for nothing heavy — ajwain and haldi for warmth, and to settle the stomach while everything is still sore.',
      /* [ASSET] harira/ajwain pack shot — this is the saunth image standing in */
      img:CDN+'1-5.webp?v=1787904285&width=400',
      alt:'Warming first-week jaapa preparation with ajwain and haldi.',
      price:'₹490', unit:'200 g · from', was:'MRP ₹590', save:'Save 17%',
      cta:'https://maamitahara.com/products/postnatal-harira-ajwain-halida-diy',
      also:[['Saunth jaapa laddu','https://maamitahara.com/products/postnatal-saunth-jaapa-laddu']],
      next:'Next change: <b>day 8</b> — gond giri begins, once richness can be handled.' },

    { from:8, to:21, tone:'#8E3A4A',
      phase:'Days 8–21 · the middle weeks',
      name:'Gond Giri Laddu', dev:'गोंद गिरी',
      why:'The strength laddu, and the one every mother-in-law names. Gond is held to support the joints and the back — and it is started only once the first week has passed and something rich can be handled.',
      img:(window.MAA_PHASE_GOND||(CDN+'1-2_63e87552-0382-4ace-92f8-19ee647bf75a.webp?v=1787982617&width=400')),   /* phase-08-21-gond-800.webp — upload and swap for the CDN URL */
      alt:'Gond giri laddu, given from the second week after delivery.',
      price:'₹490', unit:'200 g · from', was:'500 g ₹780 · MRP ₹880', save:'Save 11%',
      cta:'https://maamitahara.com/products/postnatal-gond-giri-laddu',
      also:[['Dana methi laddu','https://maamitahara.com/products/postnatal-dana-methi-laddu'],
            ['Saunth','https://maamitahara.com/products/postnatal-saunth-jaapa-laddu']],
      next:'Next change: <b>day 22</b> — battisa and panjiri begin.' },

    { from:22, to:40, tone:'#8E3A4A',
      phase:'Days 22–40 · the later weeks',
      /* [SWAPPED] Panjiri was the answer here; both its variants are unavailable
         on the live store, so the selector was recommending something nobody can
         buy. Battisa belongs to these weeks too and is in stock. Swap back the
         day panjiri returns. */
      name:'Battisa Laddu', dev:'बत्तीसा',
      why:'Thirty-two herbs — the name is the recipe. The most concentrated thing in the jaapa kitchen, which is exactly why it is kept for the later weeks rather than the first.',
      img:CDN+'1-6.webp?v=1787904288&width=400',
      alt:'Battisa laddu, made from thirty-two herbs, for the later weeks of jaapa.',
      price:'₹495', unit:'200 g · from', was:'MRP ₹595', save:'Save 17%',
      cta:'https://maamitahara.com/products/postnatal-battisa-laddu',
      also:[['Nari kalyan panjiri (back soon)','https://maamitahara.com/products/postnatal-nari-kalyan-panjiri'],
            ['Gond giri','https://maamitahara.com/products/postnatal-gond-giri-laddu']],
      next:'Next change: <b>day 40</b> — the jaapa foods close and grain-led laddus take over.' },

    { from:41, to:9999, tone:'#7A5A3C',
      phase:'Day 40 onward · feeding',
      name:'Multigrain &amp; Ragi Laddu', dev:'मल्टीग्रेन · रागी',
      why:'The forty days of postpartum recovery have closed and the food changes job — from recovery to sustaining a year of feeding. Lighter, grain-led, and made to be eaten every day without tiring of it.',
      img:CDN+'Antenatal-Mom-to-be-Multigrain-Laddu-1_f6b1805f-ba98-41e4-bb0e-8c81e95889db.jpg?v=1746393805&width=400',
      alt:'Multigrain laddu made from five grains, for the months of feeding.',
      price:'₹490', unit:'200 g · from', was:'MRP ₹590', save:'Save 17%',
      cta:'https://maamitahara.com/products/postnatal-multigrain-laddu',
      also:[['Ragi laddu','https://maamitahara.com/products/ragi-during-pregnancy-third-trimester'],
            ['Dry fruit laddu','https://maamitahara.com/products/postnatal-dryfruits-laddu']],
      next:'Most mothers stay on these through the first year of feeding.' },

    /* the two states that are not days at all — slider hidden for both */
    { day:false, tone:'#A8720F',
      phase:'Pregnancy · all trimesters',
      name:'Dry Fruit Laddu', dev:'ड्राई फ्रूट',
      why:'For the carrying months. Dates, nuts and seeds, lighter than the jaapa foods, and the one most mothers keep going from the first trimester to the last.',
      img:CDN+'741f746d-22a4-4822-b9fe-f928e2bbc1cf.jpg?v=1757862545&width=400',
      alt:'Dry fruit laddu made with dates, nuts and seeds, for pregnancy.',
      price:'₹495', unit:'200 g · from', was:'MRP ₹595', save:'Save 17%',
      cta:'https://maamitahara.com/products/mom-to-be-dryfruit-laddu',
      also:[['First trimester','https://maamitahara.com/collections/first-trimester-nourishment'],
            ['All pregnancy laddus','https://maamitahara.com/collections/antenatal']],
      next:'Start the jaapa foods once the baby arrives — we\'ll remind you if you want.' },

    { day:false, tone:'#2C5745',
      phase:'Sending it to someone else',
      name:'Gift Boxes', dev:'उपहार',
      why:'The box you send when someone in the family has just delivered and you are not there to cook. Packed, labelled by phase, with a note written on it by hand.',
      img:CDN+'Gift-Boxes-Ajwain-LadduGond-Giri-laddu-Dryfruit-laddu-1.jpg?v=1746393835&width=400',
      alt:'Gift box of ajwain, gond giri and dry fruit laddus for a new mother.',
      price:'₹750', unit:'From · ships free', was:'', save:'',
      cta:'https://maamitahara.com/collections/gift-boxes',
      also:[['Prasavitri · 40 days','https://maamitahara.com/collections/combo-pakages'],
            ['Ask us what to send','https://wa.me/916375649488']],
      next:'Tell us her delivery date on WhatsApp and we\'ll pack to the right phase.' },
    { }
  ];
  if(!window.MAA_PHASES){ PHASES.pop(); }

  var day = 12, idx = 1;
  var $ = function(id){ return document.getElementById(id); };
  var answer = $('answer'), exact = $('exact'), picks = [].slice.call(document.querySelectorAll('.pick'));

  function phaseForDay(d){
    for(var i=0;i<4;i++){ if(d >= PHASES[i].from && d <= PHASES[i].to) return i; }
    return 3;
  }

  function paint(){
    if(!answer) return;
    var p = PHASES[idx];
    answer.style.setProperty('--tone', p.tone);
    $('a-phase').textContent = p.phase;
    $('a-name').innerHTML    = p.name;
    $('a-dev').textContent   = p.dev;
    $('a-why').innerHTML     = p.why;
    $('a-next').innerHTML    = p.next;
    $('a-price').textContent = p.price;
    $('a-unit').textContent  = p.unit;
    $('a-cta').href          = p.cta;
    $('a-img-link').href     = p.cta;
    $('a-was').textContent   = p.was || '';
    $('a-save').textContent  = p.save || '';
    $('a-save').style.display = p.save ? '' : 'none';
    $('a-atc').textContent   = idx === 5 ? 'Choose a gift box' : 'Add to cart';
    $('a-cta').textContent   = idx === 5 ? 'See the gift boxes' : 'See this laddu';
    var im = $('a-img'); im.src = p.img; im.alt = p.alt;
    $('a-also-links').innerHTML = p.also.filter(function(a){ return a && a[1]; }).map(function(a){
      return '<a href="'+a[1]+'">'+a[0]+'</a>'; }).join('');

    picks.forEach(function(el,i){ el.setAttribute('aria-pressed', i===idx ? 'true':'false'); });

    var dayState = p.day !== false;
    exact.hidden = !dayState;
    if(dayState){
      $('dnum').textContent = day;
      $('drange').value = day;
      $('drange').setAttribute('aria-valuetext','Day '+day+' after delivery');
      var left = 40 - day;
      $('dleft').innerHTML = left > 0
        ? '<b>'+left+' days</b> of jaapa left'
        : '<b>Jaapa is over</b> — day '+day;
    }
  }

  function setDay(d){
    day = Math.min(60, Math.max(1, d));
    idx = phaseForDay(day);
    paint();
  }

  picks.forEach(function(el,i){
    el.addEventListener('click', function(e){
      e.preventDefault();                 /* with JS off this is a real link */
      idx = i;
      if(PHASES[i].day !== false){
        /* land on the middle of the phase unless the day is already inside it */
        if(day < PHASES[i].from || day > PHASES[i].to){
          day = PHASES[i].to > 900 ? 45 : Math.round((PHASES[i].from + PHASES[i].to)/2);
        }
      }
      paint();
    });
  });

  var r = $('drange');
  if(answer){
    if(r) r.addEventListener('input', function(){ setDay(+r.value); });
    if($('dminus')) $('dminus').addEventListener('click', function(){ setDay(day-1); });
    if($('dplus'))  $('dplus').addEventListener('click',  function(){ setDay(day+1); });

    exact.hidden = false;   /* the slider only exists once JS is here */
    paint();
  }

  /* ------------------------------------------------------------------ CART
     REAL implementation. Each .atc carries data-variant-id; the button posts
     to /cart/add.js, waits for the response, refreshes the cart count from
     /cart.js, and only THEN confirms. Failures are shown, not swallowed.
     >>> DEV: in Liquid, render data-variant-id from the 200 g variant:
         <button class="atc" data-variant-id="{{ variant.id }}"> and drop the
         hardcoded ids below. Nothing else in this block needs changing.
     ------------------------------------------------------------------- */
  function updateCartCount(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('[data-mm-cart-count]').forEach(function(el){
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        });
        return c;
      }).catch(function(){ /* count is cosmetic; never block the add on it */ });
  }

  function addToCart(variantId, qty, label, btn){
    if(!variantId){ failAdd(btn, 'This size is not set up yet.'); return; }
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: Number(variantId), quantity: qty || 1 }] })
    })
    .then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw new Error(e.description || e.message || 'Could not add to cart'); });
      return r.json();
    })
    .then(function(){
      return updateCartCount();
    })
    .then(function(){
      btn.disabled = false; btn.textContent = original;
      confirmAdd(label);                      /* confirm AFTER the response */
    })
    .catch(function(err){
      btn.disabled = false; btn.textContent = original;
      failAdd(btn, err.message || 'Could not add to cart. Please try again.');
    });
  }

  function failAdd(btn, msg){
    if(!toast){ return; }
    tmsg.textContent = msg;
    toast.classList.add('show','mm-toast--err');
    clearTimeout(tTimer); tTimer = setTimeout(function(){
      toast.classList.remove('show','mm-toast--err');
    }, 6000);
  }

  /* cart confirmation — silence after a tap is the commonest D2C leak */
  var toast=$('toast'), tmsg=$('toast-msg'), tTimer;
  function confirmAdd(label){
    if(!toast){ return; }
    tmsg.textContent = 'Added — ' + label;
    toast.classList.add('show');
    clearTimeout(tTimer); tTimer=setTimeout(function(){ toast.classList.remove('show'); }, 4500);
  }
  document.addEventListener('click', function(e){
    var s = e.target.closest ? e.target.closest('.prod .size') : null;
    if(!s) return;
    var card = s.closest('.prod');
    card.querySelectorAll('.size').forEach(function(x){
      x.classList.toggle('is-on', x === s);
      x.setAttribute('aria-pressed', x === s ? 'true' : 'false');
    });
    var atc = card.querySelector('button.atc');
    if(atc){
      atc.setAttribute('data-variant-id', s.dataset.variantId);
      atc.textContent = 'Add ' + s.dataset.option + ' to cart';
    }
    var mrp = card.querySelector('[data-mrp]');
    if(mrp){
      var price = Number(s.dataset.price || 0);
      var ca = Number(s.dataset.compareAt || 0);
      if(price > 0 && ca > price){
        mrp.hidden = false;
        mrp.querySelector('.was').textContent = s.dataset.compareText || '';
        mrp.querySelector('.save').textContent = 'Save ' + Math.round((ca - price) / ca * 100) + '%';
      } else {
        mrp.hidden = true;
      }
    }
  });
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('button.atc') : null;
    if(!b || !b.closest('.prod')) return;
    if(b.disabled) return;
    var card = b.closest('.prod');
    addToCart(b.dataset.variantId, 1, (card.querySelector('h3')?card.querySelector('h3').textContent.trim():'') +
      (b.dataset.unit ? ' '+b.dataset.unit : ''), b);
  });
var aAtc=$('a-atc');
  if(aAtc) aAtc.addEventListener('click', function(){
    if(idx===5){ window.location.href='https://maamitahara.com/collections/gift-boxes'; return; }
    var p = PHASES[idx];
    if(!p.variantId){ confirmAdd(p.name.replace(/&/g,'&')); return; }
    addToCart(p.variantId, 1, p.name.replace(/&/g,'&'), aAtc);
  });
  updateCartCount();

  /* email sign-up success state */
  var sform=document.querySelector('.sform');
  if(sform) sform.addEventListener('submit', function(e){
    e.preventDefault();
    var em=$('em');
    if(!em.value || em.value.indexOf('@')<0){
      em.setAttribute('aria-invalid','true');
      if(!sform.nextElementSibling.classList.contains('err')){
        var p=document.createElement('p'); p.className='err'; p.textContent='That email address is missing an @ — check and try again.';
        sform.after(p);
      }
      return;
    }
    sform.innerHTML = '<p class="ok">Done. The first note arrives on day one.</p>';
  });


  /* click-to-load video: nothing streams on first paint */
  document.querySelectorAll('.vid').forEach(function(box){
    var btn = box.querySelector('button'); if(!btn) return;
    btn.addEventListener('click', function(){
      var src = box.dataset.src; if(!src) return;
      var v = document.createElement('video');
      v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true; v.preload = 'none';
      box.innerHTML = ''; box.appendChild(v);
    });
  });

})();
